<template>  
        <v-flex xs12>
            <v-menu 
                transition="slide-y-transition"
                bottom
                right
            >
            <template v-slot:activator="{ on }">
                <v-btn fluid style="margin: 0px; padding: 0px; width: 100%"
                    large
                    color="primary"
                    v-on="on" 
                                                   
                    >
                    <v-layout row wrap>
                    <v-flex xs11 justify-left style="color:white">
                        <span  v-if="ltype=='0'">{{getLanguagePrimary.name}}</span> 
                        <span  v-if="ltype=='1'">{{getLanguagePrimary.name}}</span> 
                        <span  v-if="ltype=='2'">{{getLanguageSecondary.name}}</span>
                    </v-flex>
                    <v-flex xs1 justify-right>
                        <v-icon>mdi-menu-down</v-icon>
                    </v-flex>
                    </v-layout>
                    </v-btn>
 
            </template>
                <v-list v-show="getLanguageList">
                <v-list-item
                    v-for = "lang in getLanguageList" 
                    :key="lang.id"
                    @click="changeLanguage(lang)"            
                >
                    <v-list-item-title>{{ lang.name }}</v-list-item-title>
                </v-list-item>
                </v-list>
            </v-menu>
        </v-flex>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
    data() {
        return {
          
        }
    },
    props: ['ltype'],
    computed: 
            mapGetters([
                            'getLanguagePrimary',   
                            'getLanguageSecondary',
                            'getLanguagePrimaryTmp',   
                            'getLanguageSecondaryTmp',
                            'getLanguageList'
                        ])
    ,
    methods: {
        changeLanguage(lang) {
            if(lang) {
                // change primary 
                if (this.ltype == '1') {
                        if (this.getLanguageSecondary == lang) {
                            // xxx add dialog not possible
                            return
                        }
                        this.$store.commit('setLangPrimaryTmp',this.getLanguagePrimary)
                        this.$store.commit('setLangPrimary',lang)
                        this.$store.commit('setRefresh1',true)
                }
                // change secondary
                if (this.ltype == '2')  { 
                        if (this.getLanguagePrimary == lang) {
                            // xxx add dialog not possible
                            return
                        }
                        
                        this.$store.commit('setLangSecondaryTmp',this.getLanguageSecondary)
                        this.$store.commit('setLangSecondary',lang)
                        this.$store.commit('setRefresh2',true)
                }
                // change simple
                if (this.ltype == '0')  { 
                    this.$store.commit('setLangPrimary',lang)
                    this.$store.commit('setLanguageChanged', true)
                }
            }
        }
    }
}

</script>

